module.exports = __webpack_public_path__ + "static/media/thumbnail.4fec1b3d.jpg";